export default __webpack_public_path__ + "static/media/drsMainImage.f3aa6c3a.jpg";